
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import SessaoAuth from "../../Hooks/SessaoAuth";

const RequireAuth = ({ children }) => {
  const { sessao } = SessaoAuth();
  const location = useLocation();

  if (!sessao) {
    // Redireciona para a página de login, preservando a URL para retorno após login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RequireAuth;
